export const formatCurrency = (value: number): string => {
    if (isNaN(value) || value === 0) return '$0.00'
    value = parseFloat(value.toString().replace('-', ''))
    return '$' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  }
  